import {useEffect} from 'react';
import {WebviewUtils} from '@shared/webviewUtils';

/**
 * 한국도로공사 결제 플로우상, 이 페이지에서 할일은 없고 닫히면 됨
 * @see https://hmg.dooray.com/project/tasks/4115708570395933771
 */
function PaymentExpressPayCallbackPage() {
  const queryString = new URLSearchParams(window.location.search);
  const status = queryString.get('status');
  const paymentId = queryString.get('paymentId');

  useEffect(() => {
    if (status && paymentId) {
      window.localStorage.setItem(`express-pay-${paymentId}`, status);
    }
    WebviewUtils.close();
  }, []);

  return null;
}

export default PaymentExpressPayCallbackPage;
